import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

const MetricsSearch = ({ value, onChange, placeholder }) => (
  <div className="relative">
    <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    <Input
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      className="h-10 rounded-lg border-border/70 bg-card pl-10 text-sm shadow-sm placeholder:text-muted-foreground"
    />
  </div>
);

export default MetricsSearch;
